import Grid from './Grid';
import { Grid3Component } from './type';

const Grid3: Grid3Component = ({ children, ...props }) => (
  <Grid columns={{ md: 3, xs: 1 }} {...props}>
    {children}
  </Grid>
);

Grid3.Item = Grid.Item;
Grid3.Centered = Grid.Centered;

export default Grid3;
